
import { defineComponent, PropType } from 'vue';
import { _CreatedApp } from '../composables/useAppInfo';
import { IAppManageInfoLog } from '@/api/manage-app/app-manage/index.d';

export default defineComponent({
  name: 'AppLogs',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    logData: {
      type: Array as PropType<IAppManageInfoLog[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const {
      tableLoading,
      handleLogClose,
    } = _CreatedApp({}, emit);

    return {
      tableLoading,
      handleLogClose,
    };
  },
});
